import { render, staticRenderFns } from "./TableStockoutChangesIndex.vue?vue&type=template&id=349e9852&scoped=true&"
import script from "./TableStockoutChangesIndex.vue?vue&type=script&lang=js&"
export * from "./TableStockoutChangesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e9852",
  null
  
)

export default component.exports